import { useState, useRef , useEffect } from "react";
import { services, aboutUsContent } from "../content/content";
import { FaArrowAltCircleRight } from "react-icons/fa";

const Companyabout = () => {
  const [activeService, setActiveService] = useState(null);

  useEffect(() => {
    const elements = document.querySelectorAll(".fade-in, .slide-up");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className="w-full font-sans">
      <div className="flex flex-col md:flex-row px-4 md:px-8 bg-white z-20">
        <div
         
          className="w-full md:w-72 bg-white md:mt-[-110px] p-8 shadow-lg rounded-md fade-in"
        >
          <h2 className="text-3xl font-extrabold font-sans mb-6 text-gray-700">
            What We Do?
          </h2>
          <ul className="space-y-4">
            {services.map((service, index) => (
             
             
             <li
  key={index}
  className="flex items-start gap-2 text-lg leading-tight font-sans font-bold text-gray-500 hover:text-blue-900 cursor-pointer"
  onMouseEnter={() => setActiveService(service)}
>
  <FaArrowAltCircleRight className="text-xl mt-1 flex-shrink-0" />
  <span>{service.name}</span>
</li>
            ))}
          </ul>
        </div>

        <div
        
          className="ml-0 md:ml-6 flex-1 bg-white p-8 mt-4 md:mt-0 shadow-lg rounded-md fade-in"
        >
          {activeService ? (
            <div className="flex flex-col md:flex-row items-start">
              <div className="flex-1">
                <h3 className="text-2xl font-bold font-sans mb-4 text-gray-800">
                  {activeService.name}
                </h3>
                <p className="text-lg text-gray-700 leading-loose text-justify">
                  {activeService.description}
                </p>
              </div>
              <div className="mt-4 md:mt-0 md:ml-6 w-full md:w-60 h-60 flex-shrink-0">
                <img
                  src={activeService.icon}
                  alt={activeService.name}
                  className="w-60 h-60 object-cover rounded-md"
                />
              </div>
            </div>
          ) : (
            <p className="text-lg text-gray-500">
              {aboutUsContent.defaultServiceDescription}
            </p>
          )}
        </div>
      </div>

      {/* <div className="w-full bg-white py-16 fade-in">
        <div className="flex flex-col lg:flex-row items-center max-w-7xl mx-auto px-4 md:px-8 gap-8">
          <div className="lg:w-1/2 text-left">
            <h2 className="text-4xl font-bold text-gray-700 mb-6 mx-4 relative inline-block pb-2 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-16 after:h-1 after:bg-yellow-400">
              {aboutUsContent.title}
            </h2>
            <p className="text-[#313131] text-sm mx-4 font-sans leading-relaxed text-justify mb-6">
              {aboutUsContent.description}
            </p>
            <button
              onClick={() => (window.location.href = "/company-profile")}
              className="bg-blue-600 text-white mx-4 py-2 px-6 rounded-md hover:bg-blue-700 transition"
            >
              {aboutUsContent.buttonText}
            </button>
          </div>

          <div className="flex justify-center transform transition-all duration-[1800ms] ease-in-out lg:mt-0 mt-4 md:mt-0 md:ml-6 w-full md:w-80 lg:w-2/5 h-auto flex-shrink-0 fade-in">
            <img
              src={aboutUsContent.image}
              alt="Industry"
              className="w-full h-full rounded-lg shadow-xl object-cover"
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Companyabout;
